import { Link, useParams } from 'react-router-dom';

import { EmptyStatePanel } from '@/designSystem/molecules/EmptyStatePanel';

/**
 * Single-agent stub for `/agents/:id` deep links.
 */
export function AgentDetailPage() {
  const { id } = useParams<{ id: string }>();

  return (
    <div data-testid="agents-agent-detail">
      <header data-testid="agents-agent-detail-header" className="mb-6">
        <h1 className="text-2xl font-semibold text-primary">Agent {id ?? 'unknown'}</h1>
        <p className="mt-2 text-secondary">
          Builder editor and runtime settings will live on this route.
        </p>
      </header>

      <EmptyStatePanel
        data-testid="agents-agent-detail-empty-state"
        icon="Robot"
        title="Builder coming soon"
        description="This route preserves deep links for the no-code editor and deployment pipeline in later phases."
      >
        <Link to="/agents" data-testid="agents-agent-detail-back-link" className="ds-link">
          Back to agents
        </Link>
      </EmptyStatePanel>
    </div>
  );
}
